import { useId, cloneElement } from 'react';

export const inputCls = 'w-full border border-amber-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-amber-400';

export function Field({ label, hint, children }) {
  const id = useId();
  return <div>
    <label htmlFor={id} className="block text-sm font-medium text-amber-700 mb-1">{label}</label>
    {hint && <p id={`${id}-hint`} className="text-xs text-amber-600 mb-2">{hint}</p>}
    {['input', 'textarea', 'select'].includes(children?.type)
      ? cloneElement(children, { id, 'aria-describedby': hint ? `${id}-hint` : undefined }) : children}
  </div>;
}

export function Section({ step, title, blurb, children }) {
  return <section className="border border-amber-100 rounded-xl p-4 space-y-4">
    <div>
      <h3 className="text-sm font-semibold text-amber-800 flex items-center gap-2">
        <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-amber-100 text-amber-600 text-xs flex-shrink-0">{step}</span>
        {title}
      </h3>
      {blurb && <p className="text-xs text-amber-600 mt-1">{blurb}</p>}
    </div>
    {children}
  </section>;
}
